import React from "react";
import { Col, Container, Row, Accordion } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Ditigalgcc({ rtl }) {
  const className = rtl
    ? "tekrevol_gray_bg acc_section p-100 rtl-style"
    : "tekrevol_gray_bg acc_section p-100";
  return (
    <div className={className}>
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h2>حلول لنشاطك التجاري</h2>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              إذا كنت تبحث إلى تطوير رقمي لنشاطك التجاري، فلا داعي لمزيد من
              البحث، لأن هذا ما يميزنا. نقدم أفضل ما لدينا، تحقق من قائمة
              خدماتنا
            </p>
          </Col>
        </Row>
        <Row>
          <Accordion defaultActiveKey="">
            <Accordion.Item eventKey="0">
              <Accordion.Header>تطوير تطبيقات أندرويد محلية</Accordion.Header>
              <Accordion.Body>
                <div className="acc_content">
                  <div className="acc_txt">
                    <p>
                      ينتج فريقنا في تطوير تطبيقات الجوال دبي محلية لنظام
                      أندرويد تعتمد على لغات Kotlin و Java و C++. كما نستخدم
                      حزمة تطوير برمجيات أندرويد و Firebase و Android Jetpack
                      وأدوات سطر الأوامر من أجل تطوير تطبيقات لسوق جوجل بلاي.
                    </p>
                    <p>
                      وبالإضافة لأدوات جوجل الخاصة، نمتلك حلول أطراف ثالثة مخصصة
                      لتطوير تطبيقات أندرويد المحلية تؤمن درجة أعلى من الأمان
                      ومظهر وشكل متناسق ووصول مباشر إلى الميزات الجديدة، وكذلك
                      امتثال تام بتوجيهات سوق التطبيقات.
                    </p>
                    <Link
                      to="/contact"
                      className="border_btn dark_btn"
                      aria-label="TekRevol Contact"
                    >
                      بناء تطبيق أندرويد
                    </Link>
                  </div>
                  <div className="acc_img">
                    <StaticImage
                      src="../../../images/locationgcc/sa/androidapp.webp"
                      alt="mobile app development company in dubai"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={470}
                      height={720}
                    />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                تطويتطوير تطبيقات آي أو إس محلية
              </Accordion.Header>
              <Accordion.Body>
                <div className="acc_content">
                  <div className="acc_txt">
                    <p>
                      تستهدف خبرات تيك ريفول في تصميم تطبيقات آي أو إس المحلية
                      بشكل خاص الشركات التي تسعى للاستفادة من حزمة تطوير برمجيات
                      آي أو إس.
                    </p>
                    <p>
                      وتدعم شركة تطوير التطبيقات العملاء في مختلف القطاعات
                      لزيادة قيمة شركاتهم وقاعدة عملائهم باستخدام تطبيقات آي أو
                      إس محلية تتمتع بجودة عالية قادرة على كسب شعبية كبيرة في
                      سوق التطبيقات.
                    </p>
                    <p>
                      تستهدف خبرات تيك ريفول في تصميم تطبيقات آي أو إس المحلية
                      بشكل خاص الشركات التي تسعى للاستفادة من حزمة تطوير برمجيات
                      آي أو إس.
                    </p>
                    <Link
                      to="/contact"
                      className="border_btn dark_btn"
                      aria-label="TekRevol Contact"
                    >
                      إنشاء تطبيق iOS
                    </Link>
                  </div>
                  <div className="acc_img">
                    <StaticImage
                      src="../../../images/locationgcc/sa/iosapp.webp"
                      alt="mobile app development company in dubai"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={470}
                      height={720}
                    />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>تطوير التطبيقات المختلطة</Accordion.Header>
              <Accordion.Body>
                <div className="acc_content">
                  <div className="acc_txt">
                    <p>
                      استفد من خدمات شركتنا المعنية في تطوير تطبيقات الجوال في
                      دبي للحصول على تطبيقات مختلطة متخصصة تتشارك فيما بينهما
                      بنفس الرمز البرمجي على عدة منصات.
                    </p>
                    <p>
                      وهدفنا من ذلك هو مساعدة العملاء من خلال تطبيقات مركزية
                      مألوفة تشغل جزء كبيراً من واجهة المستخدم ضمن متصفح مدمج.
                      ويمتلك التطبيق ميزات منصتي أندرويد وآي أو إس ضمن إطار
                      العمل ذاته.
                    </p>
                    <p>
                      وبدلاً من توجيه مطورينا لبرمجة رموز التطبيق من البداية لكل
                      منصة على حدا، نكتب قسماً من رمز التطبيق بلغات HTML5 و CSS3
                      و JavaScript فيصبح قابلاً لإعادة الاستخدام ضمن مختلف أنظمة
                      الجوال
                    </p>
                    <Link
                      to="/contact"
                      className="border_btn dark_btn"
                      aria-label="TekRevol Contact"
                    >
                      إنشاء تطبيق Hybird
                    </Link>
                  </div>
                  <div className="acc_img">
                    <StaticImage
                      src="../../../images/locationgcc/sa/hybridapp.webp"
                      alt="mobile app development company in dubai"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={470}
                      height={720}
                    />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Row>
      </Container>
    </div>
  );
}

export default Ditigalgcc;
